import { render, staticRenderFns } from "./TreeContainer.vue?vue&type=template&id=5845fb09&scoped=true&"
import script from "./TreeContainer.vue?vue&type=script&lang=ts&"
export * from "./TreeContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TreeContainer.vue?vue&type=style&index=0&id=5845fb09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5845fb09",
  null
  
)

export default component.exports